var doubleHover = function(selector, hoverClass) {
    $(document).on('mouseover mouseout', selector, function(e) {
        $(selector)
            .filter('[href="' + $(this).attr('href') + '"]')
            .toggleClass(hoverClass, e.type == 'mouseover');
    });
};

doubleHover('.double-hover', 'hover');